import { useState } from 'react';
import dayjs from 'dayjs';
import { getMedicamentosTramitesPorDelegacion } from '../../../../../../services/Busquedas/MedicamentosTramites';

export const useMedicamentosTramitesPorDelegacionData = ({
  idDivision,
  idTipoCobertura,
  fechaDesde,
  fechaHasta,
}) => {
  const [state, setState] = useState({
    isLoading: false,
    hasError: false,
    errorMessage: null,
    successMessage: null,
  });

  const [tramitesPorDelegacionAnualList, setTramitesPorDelegacionAnualList] = useState();
  const [tramitesPorDelegacionMensualList, setTramitesPorDelegacionMensualList] = useState();

  const currentMonthDateRange = {
    fechaDesde: dayjs().startOf('month').format('YYYY-MM-DD'),
    fechaHasta: dayjs().endOf('month').format('YYYY-MM-DD'),
  };

  const currentYearDateRange = {
    fechaDesde: dayjs().startOf('year').format('YYYY-MM-DD'),
    fechaHasta: dayjs().endOf('year').format('YYYY-MM-DD'),
  };

  /**
   * Recibe como parametro una función helper y controla su response
   * @param {function} callback
   * @returns response: Object
   */
  const apiCall = async (callback, data) => {
    setState({ ...state, isLoading: true });
    const response = await callback(data);

    setState({
      ...state,
      isLoading: false,
    });

    return response;
  };

  /**
   * Obtiene una lista de solicitudes de cobertura del año actual
   */
  const getTramitesPorDelegacionAnualList = async () => {
    const list = await apiCall(getMedicamentosTramitesPorDelegacion, {
      fechaDesde: currentYearDateRange.fechaDesde,
      fechaHasta: currentYearDateRange.fechaHasta,
      idDivision,
      idTipoCobertura,
    });

    setTramitesPorDelegacionAnualList(convertirToNumber(list));
  };

  /**
   * Obtiene una lista de solicitudes de cobertura del mes actual
   */
  const getTramitesPorDelegacionMensualList = async () => {
    const list = await apiCall(getMedicamentosTramitesPorDelegacion, {
      fechaDesde: currentMonthDateRange.fechaDesde,
      fechaHasta: currentMonthDateRange.fechaHasta,
      idDivision,
      idTipoCobertura,
    });

    setTramitesPorDelegacionMensualList(convertirToNumber(list));
    setState({ ...state, isLoading: false });
  };

  const convertirToNumber = (list = []) => {
    return list.map((item) => ({
      ...item,
      cantidad_pendientes: Number(item.cantidad_pendientes) || 0,
      cantidad_autorizados: Number(item.cantidad_autorizados) || 0,
      demora_0_3_dias: Number(item.demora_0_3_dias) || 0,
      demora_4_7_dias: Number(item.demora_4_7_dias) || 0,
      demora_mas_7_dias: Number(item.demora_mas_7_dias) || 0,
    }));
  };

  return {
    ...state,
    fechaAnioActual: currentYearDateRange.fechaDesde,
    fechaMesActual: currentMonthDateRange.fechaDesde,
    getTramitesPorDelegacionAnualList,
    getTramitesPorDelegacionMensualList,
    tramitesPorDelegacionAnualList,
    tramitesPorDelegacionMensualList,
  };
};
